import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from '@big-direkt/state/user';
import { translateSignal } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-user-data',
    templateUrl: './user-data.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
})
export class UserDataComponent {
    private readonly userService = inject(UserService);
    private readonly userProfile = toSignal(this.userService.getProfile());

    public readonly viewMode = input.required<'breaking-left' | 'inline'>();
    public readonly classList = input('block');

    public readonly hasUserData = output<boolean>();

    public readonly userData = computed(() => {
        const hasUserData = this.userService.isAuthenticated();
        this.hasUserData.emit(hasUserData);

        return hasUserData ? this.userProfile() : undefined;
    });

    public readonly id = computed(() => this.userData()?.identifier.distributionPartnerNumber ?? this.userData()?.identifier.healthInsuranceNumber ?? '');
    public readonly idLabelTranslation = translateSignal(
        computed(() => `uiUserData.${this.userData()?.identifier.distributionPartnerNumber ? 'distributionPartnerId' : 'insuranceNumber'}`),
    );
}
